import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage36 from "../../../../assets/PDFViewerImages/PDFViewerImage36.jpg";

const Chapter19 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 19 */}
                <section id="section19" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter19Title}</h2>

                    <div className="image-box">
                        <img src={PDFViewerImage36} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter19Paragraph1}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter19Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter19Paragraph3}

                    </p>


                </section>

        </>
    )

}

export default Chapter19;
